import { BLOCK_TYPES } from '../Content/const';
import { CHECK_IN_ICON } from './const';
import { BlockDraft } from './draft';

export const blockInfo = ({ content, checkIn }: BlockDraft) => {
  if (checkIn) {
    return {
      icon: CHECK_IN_ICON,
      typeLabel: 'Check-in',
      title: checkIn.title || 'Untitled check-in',
    };
  }

  const type = BLOCK_TYPES.find(({ value }) => value === content?.type);

  return {
    icon: type?.icon,
    typeLabel: type?.label ?? content?.type ?? 'Block',
    title: content?.title || content?.slug || 'Untitled block',
  };
};
